import React, { useState } from "react";
import { useSelector } from "react-redux";

import { CalendarField, CheckboxField, TextAreaField, TextInputField } from "../../../helpers";
import { getPaymentTermsString } from "../../../utils";


const QuotationDetails = (props) => {
    const { buyerQuote, setBuyerQuote, allCompanyBillAddresses, buyerCompanyDetails, pmCompanyConfig } = props

    const [budgetaryFlag, setBudgetaryFlag] = useState(false)
    const companyCreditPeriods = useSelector((state) => state.common.companyCreditPeriods)

    const handleRemarks = (event) => {
        buyerQuote.remarks = event.target.value
        // console.log("upadatedBuyerQuote", upadatedBuyerQuote)
        setBuyerQuote({...buyerQuote})
    }

    const handleBuyerQuoteValidUptoChange = (event) => {
        const { name, value, type, checked } = event.target
        if (type === "checkbox") {
            setBudgetaryFlag(checked)
            buyerQuote[name] = checked
        } else {
            buyerQuote[name] = value
        }
        setBuyerQuote({ ...buyerQuote })
    }

    const buyerGSTIN = allCompanyBillAddresses?.find(eachBillAddr => eachBillAddr.billAddrId === buyerQuote.billAddrId)?.gstinCode

    const paymentTermStringResponse = getPaymentTermsString(buyerQuote.paymentTerms, companyCreditPeriods)
    // console.log("buyerQuote", buyerQuote)

    let vendorCodes = null 
    if(buyerCompanyDetails.vendorCode?.length > 0){
        vendorCodes = buyerCompanyDetails.vendorCode.map(eachCompany => eachCompany.code)
        vendorCodes = vendorCodes.join(", ")
    }

    let validUptoMaxDate = new Date()
    validUptoMaxDate.setDate(validUptoMaxDate.getDate() + 15);

    return(
        <>
            <div>
                <h5 className="text-600 mb-1">Quotation Details</h5>
            </div>
            <div className="p-card mb-0">
                <div className="flex">
                    <div className="flex flex-column col-12 mb-2 lg:col-5 lg:mb-0 pl-0">
                        <div className="grid">
                            <div className="flex flex-column col-12 mb-2 lg:col-4 lg:mb-0">
                                <TextInputField name="" labelText='Total Price Before Tax' value={buyerQuote.bQuotTotalItemAmountBeforeTax} disabled />
                            </div>
                            <div className="flex flex-column col-12 mb-2 lg:col-4 lg:mb-0">
                                <TextInputField name="" labelText='Total Tax' value={buyerQuote.bQuotTotalPOTax} disabled />
                            </div>
                            <div className="flex flex-column col-12 mb-2 lg:col-4 lg:mb-0">
                                <TextInputField name="" labelText='Total Price' value={buyerQuote.bQuotTotalItemAmountWithTax} disabled />
                            </div>
                            <div className="flex flex-column col-12 mb-2 lg:col-12 lg:mb-0">
                                <TextInputField name="" value={buyerCompanyDetails?.companyName} labelText='Buyer Company Name ' disabled />
                            </div>
                            <div className="flex flex-column col-12 mb-2 lg:col-4 lg:mb-0">
                                <TextInputField name="" value={buyerGSTIN} labelText={`Buyer ${pmCompanyConfig.GSTINLabel}`} disabled />
                            </div>
                            <div className="flex flex-column col-12 mb-2 lg:col-4 lg:mb-0">
                                <CalendarField name="validUpto" labelText="Quotation Valid Upto" minDate={new Date()} maxDate={new Date(validUptoMaxDate)} value={new Date(buyerQuote.validUpto)} onChange={handleBuyerQuoteValidUptoChange} disabled={!buyerQuote.isNew}/>
                                {/* <TextInputField name="" labelText='Quotation validity (Days)' value={validityDays} disabled /> */}
                            </div>
                            <div className="flex flex-column col-12 mb-2 lg:col-4 lg:mb-0">
                                <TextInputField name="" value={vendorCodes} labelText='Vendor code' tooltip={vendorCodes} tooltipOptions={{position: 'top', showOnDisabled: true}} disabled />
                            </div>
                            <div className="flex flex-column col-12 mb-2 lg:col-8 lg:mb-0">
                                <TextInputField name="" labelText='Payment Term' value={paymentTermStringResponse?.paymentTermsString} disabled />
                            </div>
                            <div className="flex flex-column col-12 mb-2 lg:col-4 lg:mb-0">
                                <label className="mt-1" style={{ fontSize: '12px', marginBottom: '3px' }} htmlFor="budgetaryFlag">Budgetary Flag</label>
                                <CheckboxField name="budgetaryFlag" inputId="budgetaryFlag" value={buyerQuote.budgetaryFlag} checked={buyerQuote.budgetaryFlag} onChange={handleBuyerQuoteValidUptoChange} />
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-column col-12 mb-2 lg:col-7 lg:mb-0">
                        <label style={{ fontSize: '12px', marginBottom: '3px' }}>Remarks</label>
                        {/* <Editor value={buyerQuote.remarks} onTextChange={handleRemarks} style={{ height: '185px' }} /> */}
                        <TextAreaField maxLength={250} value={buyerQuote.remarks} onChange={handleRemarks} className="h-full" placeholder="Add remarks" />
                    </div>
                </div>
            </div>
        </>
    )
}

export default QuotationDetails;